import React, { useEffect } from "react";
import { StyledShopName, StyledTopPart } from "../Catalog/styled";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Skeleton,
  Tab,
  Tabs,
  Typography,
  Modal,
} from "@mui/material";
import {
  ArrowBackIos,
  ArrowForwardIosOutlined,
  ArrowForwardOutlined,
  ConfirmationNumberOutlined,
  Storefront,
} from "@mui/icons-material";
import { colors } from "../../theme/colors";
import { ProductName, ProductWrapper, ProductWrapperList } from "./styled";
import ErrorPage from "../../components/common/ErrorPage/ErrorPage";
import { getInitials, px2Rem } from "../../utils/functions";
import FixedVoucher from "./FixedVoucher";
import RangedVoucher from "./RangedVoucher";
import { HighlightOffOutlined } from "@mui/icons-material";
import { ModalBox } from "../Buy/styled";

export default function Shop({}) {
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [errorLoading, setErrorLoading] = useState(false);
  const [products, setproducts] = useState({
    shopProducts: [],
    shopFixedVouchers: [],
    shopRangedVouchers: [],
    productNoType: [],
    shopInfo: { logo: "" },
  });
  const [productsTab, setProductsTab] = useState(0);
  const [productsCategoryList, setProductsCategoryList] = useState([""]);
  const [isOnlyVouchers, setIsOnlyVouchers] = useState(false);
  const navigate = useNavigate();
  const [dinamicVoucher, setDinamicVoucher] = useState(false);
  const [ipError, setIpError] = useState(false);

  const handleProductsTabChange = (e, newValue) => {
    setProductsTab(newValue);
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <>{children}</>}
      </div>
    );
  }

  useEffect(() => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_BE_SERVICE}/oky/shop/products?s=${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.errorCode === "403") {
          setIpError(true);
        } else {
          setproducts(res);
          const temp = [...productsCategoryList];
          if (res.shopProducts.length > 0 || res.productNoType.length > 0)
            temp[0] = "Productos";
          if (
            res.shopFixedVouchers.length > 0 ||
            res.shopRangedVouchers.length > 0
          ) {
            if (
              res.shopProducts.length === 0 &&
              res.productNoType.length === 0
            ) {
              setIsOnlyVouchers(true);
              temp[0] = "Vales";
            } else {
              temp[1] = "Vales";
              setIsOnlyVouchers(false);
            }
          }

          setProductsCategoryList(temp);
          setLoading(false);
        }
      })
      .catch((err) => {
        setErrorLoading(true);
        setLoading(false);
      });
  }, []);

  const productsList = (prod) => {
    let list = [];

    if (loading) {
      for (let i = 0; i < 40; i++) {
        list.push(
          <Grid item lg={3} md={4} sm={4} xs={12} style={{ marginTop: "2rem" }}>
            <Grid
              container
              textAlign={"center"}
              spacing={2}
              justifyContent="center"
              alignItems={"center"}
            >
              <Grid item xs={4} lg={12} sm={12} md={12}>
                <Skeleton
                  variant="rectangular"
                  height={125}
                  animation="wave"
                  style={{ margin: "auto" }}
                />
              </Grid>

              <Grid
                item
                justifyContent="center"
                alignItems="center"
                textAlign="center"
                xs={8}
                lg={12}
                sm={12}
                md={12}
              >
                <Grid
                  container
                  textAlign="center"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid item lg={12} md={12} sm={12} xs={11}>
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "1rem" }}
                      animation="wave"
                    />
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "1rem" }}
                      animation="wave"
                    />
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "1rem" }}
                      animation="wave"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      }
    } else {
      for (let i = 0; i < prod.length; i++) {
        list.push(
          <Grid item lg={3} md={4} sm={4} xs={12} style={{ marginTop: "2rem" }}>
            <Grid
              container
              textAlign={"center"}
              spacing={2}
              justifyContent="center"
              alignItems={"center"}
              onClick={() => {
                window.scrollTo(0, 0);
                if (prod[i].productType !== "RANGE_AMOUNT") {
                  navigate(`../buy/${prod[i].voucherId}`);
                } else {
                  setDinamicVoucher(true);
                }
              }}
            >
              <Grid item xs={4} lg={12} sm={12} md={12}>
                <ProductWrapperList hasImage={prod[i].voucherImage}>
                  {prod[i].voucherImage ? (
                    <img
                      style={{ maxWidth: "100%", marginTop: "10px" }}
                      src={prod[i].voucherImage}
                      alt={prod[i].voucherName}
                    />
                  ) : (
                    <Storefront
                      sx={{ fontSize: "5rem", color: colors.white.main }}
                    />
                  )}
                </ProductWrapperList>
              </Grid>

              <Grid
                item
                justifyContent="center"
                alignItems="center"
                textAlign="center"
                xs={8}
                lg={12}
                sm={12}
                md={12}
              >
                <Grid
                  container
                  textAlign="center"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid item lg={12} md={12} sm={12} xs={11}>
                    <ProductName color={colors.gray.text} height="70px">
                      {prod[i].voucherName}
                    </ProductName>
                    <ProductName color={colors.primary}>
                      {prod[i].productType === "RANGE_AMOUNT"
                        ? `Q ${prod[i].minimumAmount} - Q ${prod[i].maximumAmount}`
                        : `Q ${prod[i].price}`}
                    </ProductName>
                  </Grid>

                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={1}
                    justifyContent={"flex-end"}
                  >
                    <Box
                      display={{
                        xs: "none",
                        sm: "block",
                        md: "block",
                        lg: "block",
                      }}
                    >
                      <Button
                        startIcon={<ConfirmationNumberOutlined />}
                        color="warning"
                        variant="contained"
                        centered
                        style={{
                          borderRadius: "50px",
                          width: "100%",
                          maxWidth: "180px",
                        }}
                        sx={{
                          ":hover": {
                            bgcolor: "primary.main",
                            color: "#FCB71C",
                          },
                        }}
                        onClick={() => {
                          if (prod[i].productType !== "RANGE_AMOUNT") {
                            navigate(`../buy/${prod[i].voucherId}`);
                          } else {
                            setDinamicVoucher(true);
                          }
                        }}
                      >
                        Comprar
                      </Button>
                    </Box>
                    <Box
                      display={{
                        xs: "block",
                        sm: "none",
                        md: "none",
                        lg: "none",
                      }}
                    >
                      <IconButton>
                        <ArrowForwardIosOutlined color="secondary" />
                      </IconButton>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      }
    }

    return list;
  };

  if (errorLoading) {
    return <ErrorPage />;
  }

  if (ipError) {
    return (
      <>
        <Modal open="true">
          <ModalBox>
            <HighlightOffOutlined color="error" style={{ fontSize: "5rem" }} />
            <Typography
              variant="h2"
              sx={{ fontSize: { xs: px2Rem(32), md: px2Rem(40) } }}
            >
              Usuario inhabilitado temporalmente
            </Typography>

            <Typography variant="body1" color="primary">
              Las solicitudes con este usuario no están disponibles en este
              momento.
            </Typography>
          </ModalBox>
        </Modal>
      </>
    );
  } else {
    return (
      <>
        <StyledTopPart height="250px" />

        {loading ? (
          <>
            <Typography
              variant="h2"
              sx={{
                color: colors.white.main,
                position: "absolute",
                top: {
                  xs: "calc(25px - 25px + 250px)",
                  md: "calc(25px - 25px + 200px)",
                },
                left: "calc(50vw)",
                transform: "translateX(-50%)",
              }}
            ></Typography>
            <Avatar
              sx={{
                width: 91,
                height: 91,
                position: "absolute",
                top: {
                  xs: "calc(100px - 25px + 300px)",
                  md: "calc(100px - 25px + 235px)",
                },
                left: "calc(50vw - 45px)",
                outline: `10px ${colors.white.main} solid`,
              }}
            >
              {" "}
              <Storefront />
            </Avatar>
          </>
        ) : (
          <Box>
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              sx={{
                position: "absolute",
                top: {
                  xs: "calc(25px - 25px + 200px)",
                  md: "calc(25px - 25px + 200px)",
                },

                "@media screen and (max-width: 600px)": {
                  fontSize: "1.5rem",
                },
                "&:hover": {
                  cursor: "pointer",
                  opacity: "0.5",
                },
              }}
              onClick={() => navigate(-1)}
              display={{ xs: "flex", md: "none" }}
            >
              <ArrowBackIos
                color="secondary"
                style={{ fontSize: "16px !important" }}
              />
              <Typography
                variant="body1"
                color="secondary"
                fontSize="16px"
                fontWeight="bold"
                paddingLeft="1rem"
              >
                Atrás
              </Typography>
            </Grid>
            <Typography
              variant="h2"
              sx={{
                color: colors.white.main,
                position: "absolute",
                top: {
                  xs: "calc(25px - 25px + 250px)",
                  md: "calc(25px - 25px + 200px)",
                },
                left: "calc(50vw)",
                transform: "translateX(-50%)",
                "@media screen and (max-width: 800px)": {
                  fontSize: "1.5rem",
                },
                textAlign: "center",
              }}
            >
              {products.shopInfo.name}
            </Typography>
            {products.shopInfo.logo ? (
              <Avatar
                sx={{
                  width: 91,
                  height: 91,
                  position: "absolute",
                  top: {
                    xs: "calc(100px - 25px + 300px)",
                    md: "calc(100px - 25px + 235px)",
                  },
                  left: "calc(50vw - 45px)",
                  outline: `10px ${colors.white.main} solid`,
                }}
                src={products.shopInfo.logo}
              >
                {" "}
              </Avatar>
            ) : (
              <StyledShopName
                style={{
                  width: 91,
                  height: 91,
                  position: "absolute",
                  top: "calc(100px - 25px + 200px)",
                  left: "calc(50vw - 45px)",
                  outline: `10px ${colors.white.main} solid`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <span>{getInitials(products.shopInfo.name)}</span>
              </StyledShopName>
            )}
          </Box>
        )}

        {!dinamicVoucher && (
          <Box
            sx={{
              maxWidth: "85%",
              margin: "auto",
              marginTop: { xs: "3rem", sm: "1rem" },
            }}
          >
            <Tabs
              value={productsTab}
              onChange={handleProductsTabChange}
              centered
            >
              {productsCategoryList.map((e, i) => (
                <Tab
                  label={e}
                  value={i}
                  sx={{ textTransform: "none", fontSize: "20px" }}
                />
              ))}
            </Tabs>
            <Divider sx={{ marginBottom: "2rem" }} />

            <CustomTabPanel value={productsTab} index={0}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                rowSpacing={5}
              >
                {productsList(products.shopProducts)}
                {productsList(products.productNoType)}
              </Grid>
            </CustomTabPanel>

            <CustomTabPanel value={productsTab} index={isOnlyVouchers ? 0 : 1}>
              {products.shopFixedVouchers.length === 0 && (
                <RangedVoucher product={products.shopRangedVouchers} />
              )}

              {products.shopRangedVouchers.length === 0 &&
                products.shopFixedVouchers.length > 1 && (
                  <FixedVoucher product={products.shopFixedVouchers} />
                )}

              {products.shopRangedVouchers.length === 0 &&
                products.shopFixedVouchers.length === 1 && (
                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                    rowSpacing={5}
                  >
                    {productsList(products.shopFixedVouchers)}
                  </Grid>
                )}

              {products.shopFixedVouchers.length !== 0 &&
                products.shopRangedVouchers.length !== 0 && (
                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                    rowSpacing={2}
                  >
                    {productsList(products.shopFixedVouchers)}
                    {productsList(products.shopRangedVouchers)}
                  </Grid>
                )}
            </CustomTabPanel>
          </Box>
        )}

        {dinamicVoucher && (
          <RangedVoucher product={products.shopRangedVouchers} />
        )}
      </>
    );
  }
}
